<template>
  <span ref="container" class="dropdown ml-1 mr-2 pr-1">
    <button
      class="btn btn-light btn-sm dropdown-toggle px-2"
      type="button"
      @click="show = !show"
    ></button>
    <div class="dropdown-menu mt-2 shadow-sm" :class="{ show }">
      <a
        v-for="role in allowedRoles"
        :key="role"
        class="dropdown-item pl-2"
        href="#"
        @click="updateRole(user, role)"
      >
        <input type="checkbox" :name="role" :checked="roles.includes(role)" />
        <span class="ml-2">{{ role }}</span></a
      >
      <hr class="mt-0 mb-2" />
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary btn-sm mr-2" @click="saveRoles(user)">
          Save
        </button>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    user: { required: true, type: Object },
    allowedRoles: { required: true, type: Array },
  },
  data() {
    return {
      roles: [...this.user.roles],
      show: false,
    }
  },
  methods: {
    saveRoles(user) {
      this.show = false
      this.$emit("save-roles", { ...user, roles: this.roles })
    },
    updateRole(user, role) {
      const index = this.roles.indexOf(role)
      if (index !== -1) {
        this.roles.splice(index, 1)
      } else {
        this.roles.push(role)
      }
    },
  },
}
</script>

<style></style>
